export default __webpack_public_path__ + "static/media/logo.c4197c58.png";